import { useEffect, useState } from 'react';
const INITIAL_SECONDS = 22 * 60 * 60 + 53 * 60 + 20;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
function getTimeLeft(totalSeconds: number): TimeLeft {
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60
  };
}
export function OfferCountdown() {
  const [remaining, setRemaining] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(current => current > 0 ? current - 1 : INITIAL_SECONDS);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const time = getTimeLeft(remaining);
  const units = [{
    value: time.hours,
    label: 'HRS'
  }, {
    value: time.minutes,
    label: 'MIN'
  }, {
    value: time.seconds,
    label: 'SEG'
  }];
  return <div className="mx-auto mb-7 max-w-2xl text-center sm:mb-8" role="timer" aria-label={`${time.hours} horas, ${time.minutes} minutos y ${time.seconds} segundos restantes`} data-id="element-94" data-mp="2wnq6c6y7k9b4">
      <p className="font-heading text-xl font-black leading-tight text-white sm:text-3xl" data-id="element-95" data-mp="26oi6nw0qdt6i">EL PRECIO ESPECIAL TERMINA EN:</p>
      <div className="mt-4 flex items-center justify-center gap-2 sm:gap-4" data-id="element-96" data-mp="21ondtmxeatit">
        {units.map((unit, index) => <div key={unit.label} className="contents" data-id="element-97" data-mp="1wtq40dsakg4v" data-mpi={index}>
            <div className="flex h-20 w-20 flex-col items-center justify-center rounded-2xl border-2 border-white/10 bg-navy-light shadow-lg shadow-black/20 sm:h-24 sm:w-24" data-id="element-98" data-mp="1rriq3inwipzw">
              <span className="font-heading text-3xl font-black tabular-nums leading-none text-white sm:text-4xl" data-id="element-99" data-mp="1izp4vixfgr3z">{String(unit.value).padStart(2, '0')}</span>
              <span className="mt-1 font-heading text-xs font-black tracking-wide text-brandgreen sm:text-sm" data-id="element-100" data-mp="1dz1ff1oukibv">{unit.label}</span>
            </div>
            {index < units.length - 1 && <span className="font-heading text-2xl font-black text-gray-500" aria-hidden="true" data-id="element-101" data-mp="141of76n57bia">:</span>}
          </div>)}
      </div>
      <p className="mt-4 font-heading text-sm font-extrabold text-white sm:text-base" data-id="element-102" data-mp="103h52un6p8g2">Después sube <span className="text-red-400" data-id="element-103" data-mp="pidj8gdajdkx">$8.000 ARS</span> y no vuelve a bajar.</p>
    </div>;
}